"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateMediaSlideCommand model module.
 * @module model/CreateMediaSlideCommand
 * @version 1.1.3-alpha.1
 */
class CreateMediaSlideCommand {
  /**
   * Constructs a new <code>CreateMediaSlideCommand</code>.
   * @alias module:model/CreateMediaSlideCommand
   * @param media_id {String} 
   * @param title {String} 
   * @param content_id {String} 
   * @param allow_comments {Boolean} 
   * @param is_topline {Boolean} 
   */
  constructor(media_id, title, content_id, allow_comments, is_topline) {
    CreateMediaSlideCommand.initialize(this, media_id, title, content_id, allow_comments, is_topline);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, media_id, title, content_id, allow_comments, is_topline) {
    obj['media_id'] = media_id;
    obj['title'] = title;
    obj['content_id'] = content_id;
    obj['allow_comments'] = allow_comments;
    obj['is_topline'] = is_topline;
  }

  /**
   * Constructs a <code>CreateMediaSlideCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateMediaSlideCommand} obj Optional instance to populate.
   * @return {module:model/CreateMediaSlideCommand} The populated <code>CreateMediaSlideCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateMediaSlideCommand();
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = _ApiClient.default.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('content_id')) {
        obj['content_id'] = _ApiClient.default.convertToType(data['content_id'], 'String');
      }
      if (data.hasOwnProperty('download_file_id')) {
        obj['download_file_id'] = _ApiClient.default.convertToType(data['download_file_id'], 'String');
      }
      if (data.hasOwnProperty('price')) {
        obj['price'] = _ApiClient.default.convertToType(data['price'], 'Number');
      }
      if (data.hasOwnProperty('allow_comments')) {
        obj['allow_comments'] = _ApiClient.default.convertToType(data['allow_comments'], 'Boolean');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = _ApiClient.default.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('is_topline')) {
        obj['is_topline'] = _ApiClient.default.convertToType(data['is_topline'], 'Boolean');
      }
      if (data.hasOwnProperty('slide_number')) {
        obj['slide_number'] = _ApiClient.default.convertToType(data['slide_number'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateMediaSlideCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateMediaSlideCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CreateMediaSlideCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    // ensure the json data is a string
    if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
      throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
    }
    // ensure the json data is a string
    if (data['content_id'] && !(typeof data['content_id'] === 'string' || data['content_id'] instanceof String)) {
      throw new Error("Expected the field `content_id` to be a primitive type in the JSON string but got " + data['content_id']);
    }
    // ensure the json data is a string
    if (data['download_file_id'] && !(typeof data['download_file_id'] === 'string' || data['download_file_id'] instanceof String)) {
      throw new Error("Expected the field `download_file_id` to be a primitive type in the JSON string but got " + data['download_file_id']);
    }
    // ensure the json data is a string
    if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
      throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
    }
    return true;
  }
}
CreateMediaSlideCommand.RequiredProperties = ["media_id", "title", "content_id", "allow_comments", "is_topline"];

/**
 * @member {String} media_id
 */
CreateMediaSlideCommand.prototype['media_id'] = undefined;

/**
 * @member {String} title
 */
CreateMediaSlideCommand.prototype['title'] = undefined;

/**
 * @member {String} content_id
 */
CreateMediaSlideCommand.prototype['content_id'] = undefined;

/**
 * @member {String} download_file_id
 */
CreateMediaSlideCommand.prototype['download_file_id'] = undefined;

/**
 * @member {Number} price
 */
CreateMediaSlideCommand.prototype['price'] = undefined;

/**
 * @member {Boolean} allow_comments
 */
CreateMediaSlideCommand.prototype['allow_comments'] = undefined;

/**
 * @member {String} description
 */
CreateMediaSlideCommand.prototype['description'] = undefined;

/**
 * @member {Boolean} is_topline
 */
CreateMediaSlideCommand.prototype['is_topline'] = undefined;

/**
 * @member {Number} slide_number
 */
CreateMediaSlideCommand.prototype['slide_number'] = undefined;
var _default = CreateMediaSlideCommand;
exports.default = _default;